import * as React from "react";
const NewsDot3 = (props) => (
  <svg
    width={5}
    height={17}
    viewBox="0 0 5 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.17442 0C0.973521 0 0 0.97352 0 2.17442C0 3.37532 0.973521 4.34884 2.17442 4.34884C3.37532 4.34884 4.34884 3.37532 4.34884 2.17442C4.34884 0.97352 3.37532 0 2.17442 0ZM1.18605 2.17442C1.18605 1.62856 1.62856 1.18605 2.17442 1.18605C2.72028 1.18605 3.16279 1.62856 3.16279 2.17442C3.16279 2.72028 2.72028 3.16279 2.17442 3.16279C1.62856 3.16279 1.18605 2.72028 1.18605 2.17442Z"
      fill="#184548"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.17442 6.32558C0.97352 6.32558 0 7.2991 0 8.5C0 9.7009 0.97352 10.6744 2.17442 10.6744C3.37532 10.6744 4.34884 9.7009 4.34884 8.5C4.34884 7.2991 3.37532 6.32558 2.17442 6.32558ZM1.18605 8.5C1.18605 7.95414 1.62856 7.51163 2.17442 7.51163C2.72028 7.51163 3.16279 7.95414 3.16279 8.5C3.16279 9.04586 2.72028 9.48837 2.17442 9.48837C1.62856 9.48837 1.18605 9.04586 1.18605 8.5Z"
      fill="#184548"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.17442 12.6512C0.97352 12.6512 0 13.6247 0 14.8256C0 16.0265 0.97352 17 2.17442 17C3.37532 17 4.34884 16.0265 4.34884 14.8256C4.34884 13.6247 3.37532 12.6512 2.17442 12.6512ZM1.18605 14.8256C1.18605 14.2797 1.62856 13.8372 2.17442 13.8372C2.72028 13.8372 3.16279 14.2797 3.16279 14.8256C3.16279 15.3714 2.72028 15.814 2.17442 15.814C1.62856 15.814 1.18605 15.3714 1.18605 14.8256Z"
      fill="#184548"
    />
  </svg>
);
export default NewsDot3;
